<template>
  <div>
    <section id="leftPane">

      <h1>アカウント編集</h1>
      <p class="warningMessage" v-if="isWarning">!未入力の項目があります!</p>

      <div id="nameInputArea">
        <h3 class="inputTitle " >名前</h3>
        <input :class="{warned: (isWarning && !name)}" type="text" placeholder="" v-model="name">
      </div>

      <div id="mailInputArea">
        <h3 class="inputTitle " >メールアドレス</h3>
        <input :class="{warned: (isWarning && !email)}" type="text" placeholder="" v-model="email">
      </div>

      <div id="passwordInputArea">
        <h3 class="inputTitle " >パスワード</h3>
        <input :class="{warned: (isWarning && !password)}" type="text" placeholder="変更しない場合は現在のパスワードを入力" v-model="password">
      </div>

      <div>
        <button id="editPasswordButton" class="button" :class="{disabled: isButtonDisabled}" @click="editAccount">更新</button>
      </div>

    </section>

    <div class="loadingBackground" v-if="isLoading">
      <div class="loadingDialog">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          :color="'#ffffff'"
        />
      </div>
    </div>
  </div>

</template>


<script>
  import {auth, db, fbFunctions} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'


  export default {
    name: 'AccountSettings',

    components: {
      HalfCircleSpinner
    },

    data () {
      return {
        originalEmail: '',
        originalName: '',

        name: '',
        email: '',
        password: '',

        isLoading: false,

        /* 入力にエラーがあるかどうかのフラグ */
        isWarning: false
      }
    },

    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },

      isButtonDisabled() {
        if(this.name && this.email && this.password){
          if(this.name !== this.originalName || this.email !== this.originalEmail || this.password){
            return false
          }
        }
        return true
      }
    },

    methods: {

      async editAccount() {
        if(this.isButtonDisabled){
          console.log("button is disabled")

          /* 未入力チェックはisButtonDisabled()で満たしているから個別にはしない */
          this.isWarning = true
          return
        }

        this.isWarning = false

        let user = auth.currentUser;
        if(!user){
          console.log('current user is null')
          return
        }

        var paramEmail = null
        var paramName = null
        var paramPassword = null
        if (this.email && (this.email !== this.originalEmail)) {
          paramEmail = this.email
        }

        if (this.name && this.name !== this.originalName) {
          paramName = this.name
        }

        if (this.password) {
          //TODO: validate Password
          paramPassword = this.password
        }


        this.isLoading = true

        try{
          var editAccount = fbFunctions.httpsCallable('editAccount');
          let result = await editAccount({
            email: paramEmail,
            //phoneNumber: '080-0000-0000',
            password: paramPassword,
            name: paramName,
          })

          let newUserEmail = result.data.email
          //let newUserPhoneNumber = result.data.phoneNumber
          let newUserName = result.data.name
          let newUserPassword = result.data.password
          console.log("Account updated", newUserEmail, newUserName, newUserPassword)

          //これで、FirebaseのAuthenticationのユーザー情報がアップデートされた。
          //次に、FirebaseのFirestore情報のadmins/以下のユーザー情報もアップデートする。

          var userInfo = {}
          if (this.name) {
            userInfo.name = this.name
          }
          if (this.email) {
            userInfo.email = this.email
          }

          await db.collection('companies').doc(this.companyId).collection('admins').doc(user.uid).update(userInfo)
          console.log("Document successfully updated!", userInfo);

          //email, passwordが変わったので再ログインする
          let data = await auth.signInWithEmailAndPassword(this.email, this.password)
          console.log("userId => ", data.user.uid);
          this.isLoading = false

          this.originalEmail = this.email
          this.originalName = this.name


          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 500) // resolve
          })
          this.$router.replace({ name: 'Home'})
        }catch(error){
          console.log('Error updating the account:', error);
          this.isLoading = false

        }
      },



      //今はFirebase Functionsでアップデートしょりをしているのでつかっていない
      updateEmail(email, newEmail, password){

        auth.signInWithEmailAndPassword(email, password).then(
          data => {
            console.log("userId => ", data.user.uid);

            if(data.user != null){
              data.user.updateEmail(newEmail).then(function() {
                console.log("User's email updated")
              }).catch(function(error) {
                console.log("Error happening in updating the user's email", error)
                //TODO:エラーの表示
              });
            }
          },
          err => {
            alert(err.message)
          }
        )

      },

      //今はFirebase Functionsでアップデートしょりをしているのでつかっていない
      updatePassword(email, password, newPassword){
        auth.signInWithEmailAndPassword(email, password).then(
          data => {
            console.log("userId => ", data.user.uid);

            if(data.user != null){
              data.user.updatePassword(newPassword).then(function() {
                console.log("User's password updated")
              }).catch(function(error) {
                console.log("Error happening in updating the user's password")
                //TODO:エラーの表示
              });
            }
          },
          err => {
            alert(err.message)
          }
        )
      },

      async getAdminInfo(uid){
        //this.isLoading = true


        /* companyIdを使ってこのユーザーが実際にadminユーザーかを調べる。adminユーザーであればログインする */
        let adminDataPromise = db.collection('companies').doc(this.companyId).collection('admins').doc(uid).get()
        let doc = await adminDataPromise

        //this.isLoading = false

        if (doc.exists) {
          console.log("Document data:", doc.data());
          this.name = doc.data().name
          this.originalName = this.name
        } else {
          // doc.data() will be undefined in this case
          console.log("This user is not admin user (maybe driver or simply not registered to this company)");
        }

      }

    },



    mounted() {
      let user = auth.currentUser;
      if(user != null){
        this.email = user.email
        this.getAdminInfo(user.uid)
        this.originalEmail = this.email
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>




  #leftPane {
    text-align: left;
    margin-left: 7%;
  }

  #leftPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  h2 {
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin-top: 40px;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0;
  }

  input {
    width: 300px;
    height: 35px;
    margin-top: 0;
  }


  #mailInputArea input {
    width: 400px;
  }

  #editPasswordButton {
    margin-bottom: 40px;
  }

  .inputTitle {
    color: #5C5C5C;
    font-size: 20px;
    font-weight: lighter;
    margin-top: 2px;

  }

  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /* 未入力の項目の警告用スタイル */
  .warned {
    background-color: #F3C99F;
  }

  .warningMessage {
    color: #FF6B49;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
  }


  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border:2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }


  @media(max-width: 400px){

    #leftPane {
      text-align: center;
      margin: 0 auto 0 auto;
    }

    #leftPane h1{
      text-align: left;
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 39px;
      margin-left: 25px;
    }

    /* 未入力の項目の警告用スタイル */
    .warned {
      background-color: #F3C99F;
    }

    .warningMessage {
      color: #FF6B49;
      font-size: 15px;
      margin-top: 0;
      margin-bottom: 0;
    }

    .inputTitle {
      text-align: left;
      color: #5C5C5C;
      font-size: 15px;
      font-weight: lighter;
      margin-top: 2px;
      margin-left: 25px;
      margin-bottom: 0;
    }

    input {
      width: 86%;
      margin: 0 auto 0 auto;
      height: 28px;
      padding: 10px;
      border-style: solid;
      border-width: 1px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border:2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #mailInputArea input {
      width: 86%;
    }

    .button {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 25px;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/AccountSettings.vue